{
  "accept": "Godkend",
  "acceptAll": "Godkend alle",
  "action": "handling",
  "addCustomerResponse": "Tilføj kundens svar",
  "addCustomerResponse.warning.headline": "Du kan ikke tilføje kundens svar på nuværende tidspunkt",
  "addCustomerResponse.warning.message": "Der er ikke tilknyttet dokumenter i Øvrige dokumenter mappen. Det kan skyldes, at der endnu ikke er modtaget et svar fra kunden, eller at svaret ikke er arkiveret i Workzone.",
  "addNote": "Tilføj note",
  "addNoteToFinance": "Tilføj note til finans",
  "allocation": "bevilling",
  "allocation_specific": "bevillingen",
  "allocation.remainingAmount": "Resterende bevilling",
  "allocationAmount": "Bevillingsstørrelse",
  "allocationName": "Bevillingsnavn",
  "and": "og",
  "and_synonym": "samt",
  "app.title": "Låneportal",
  "back": "Tilbage",
  "calculation_one": "beregning",
  "calculation_other": "beregninger",
  "calendar.latestBankDay": "Seneste bankdag",
  "calendar.selectAllYears": "Vælg alle år",
  "cancel": "Annuller",
  "cancelled": "Annulleret",
  "case_one": "sag",
  "case_other": "sager",
  "case_specific": "sagen",
  "case_specific_other": "sagerne",
  "close": "luk",
  "company_one": "kunde",
  "company_other": "kunder",
  "company_specific": "kunden",
  "company_specific_other": "kunderne",
  "company.companyResponsible": "Rådgiver",
  "company.endDateKYC": "KYC Legitimering",
  "company.segment": "Segmentering",
  "companyResponsible": "Kundeansvarlig",
  "complete": "Gennemfør",
  "contact": "Kontakt",
  "contact.missingEmail": "Mangler $t(common:email)",
  "contact.missingPhone": "Mangler $t(common:phone)",
  "contactPerson_one": "Kontaktperson",
  "contactPerson_other": "Kontaktpersoner",
  "contact.updated": "Kontaktperson opdateret",
  "continue": "Fortsæt",
  "contractGeneration.newLoan.calculation.summary": "{{ productType }}, {{ amount, currency }} {{ currencyCode }}, {{ years }} år",
  "contractGeneration.redemption.calculation.summary": "{{ amount, currency }} {{ currencyCode }}, {{ date, date }}, {{ repaymentMethod }}",
  "copiedToClipboard": "Kopieret til udklipsholderen",
  "copyMasterData": "Kopier stamdata",
  "copyToClipboard": "Kopier til udklipsholder",
  "created": "Oprettet",
  "currency": "valuta",
  "customerResponseAlreadyExists.headline": "Der er registreret et dokument i aftaleindgåelse.",
  "customerResponseAlreadyExists.message": "Flyt dokumentet fra mappen 'Aftaleindgåelse' til mappen 'Øvrige dokumenter' og prøv igen.",
  "cvr": "CVR",
  "cvrNumber": "CVR-nummer",
  "dashboard": "Dashboard",
  "dashboard.noViewedCases": "Ingen sete sager",
  "dashboard.recentlyViewedCases": "Mine senest sete sager",
  "date": "Dato",
  "delete": "slet",
  "department.TRE": "$t(common:finance)",
  "department.FIN_BAER": "$t(common:finance)",
  "department.FIN_FUN": "$t(common:finance)",
  "department.FIN_INV": "$t(common:finance)",
  "department.KOF": "KOF",
  "department.LAAN": "LAAN",
  "department.LEAS": "LEAS",
  "department.OEKO": "$t(common:economy)",
  "department.BAC": "$t(common:economy)",
  "department.RGN": "$t(common:economy)",
  "disbursement_one": "udbetaling",
  "disbursement_other": "udbetalinger",
  "document_one": "Dokument",
  "document_other": "Dokumenter",
  "documentPanel.remainingDocuments": "Øvrige dokumenter",
  "documentPanel.zeroDocumentsLabel": "Der er ingen dokumenter tilknyttet",
  "economy": "økonomi",
  "edit": "rediger",
  "edit.recipient": "Redigér modtager",
  "email": "E-mail",
  "error.api.message": "Kontakt Projekt Låneportal ved Jesper Bruun (JBR) eller Mathias Marcussen (MMA) og oplys følgende; fejltype, fejltidspunkt, udløsende handling og forventet resultat",
  "error.api.title": "API fejl på siden",
  "error.companyNumberMissing": "Kundenummer mangler",
  "error.component.message": "Kontakt Projekt Låneportal ved Jesper Bruun (JBR) eller Mathias Marcussen (MMA) og oplys følgende; fejltype, fejltidspunkt, udløsende handling og forventet resultat.",
  "error.component.title": "Komponent på siden fejler",
  "error.copy.button": "Kopier fejlbesked",
  "error.copy.failure.headline": "Kopiering fejlede",
  "error.copy.failure.message": "Kunne ikke kopiere fejldetaljer",
  "error.copy.success.headline": "Kopieret til udklipsholder",
  "error.copy.success.message": "Fejldetaljer er blevet kopieret",
  "error.generic": "Der skete en fejl",
  "error.noAccess": "Du har ikke adgang til portalen",
  "error.noCompanyFound": "Kundedata findes ikke",
  "error.noIndustryCodes": "Branchekoder kunne ikke hentes",
  "error.noLoanInfo": "Aftaledata findes ikke",
  "error.stack.collapse": "Vis mindre",
  "error.stack.expand": "Vis mere",
  "error.validation": "Valideringsfejl",
  "estimated": "Estimeret",
  "excel": "Excel",
  "export": "Eksporter",
  "feature.inDevelopment": "Funktionaliteten er under udvikling",
  "fetchingData": "Henter seneste data",
  "fillIn": "Udfyld",
  "filter.active": "Aktive",
  "filter.cancelled": "Annullerede",
  "filter.label": "Filter",
  "finance": "finans",
  "fixedInterestPeriodType": "rentebinding",
  "goTo": "Gå til {{ target }}",
  "industryCode": "branchekode",
  "information": "oplysninger",
  "lastUpdate": "Sidst opdateret: {{lastUpdate, dateTime}}",
  "loan_one": "Aftale",
  "loan_other": "Aftaler",
  "loan_specific": "Aftalen",
  "loan_specific_other": "Aftalerne",
  "loanPeriod": "løbetid",
  "loanPeriod_specific": "løbetiden",
  "loanAgreement": "Låneaftale",
  "missingEmail": "Mangler e-mail",
  "mitId": "MitID",
  "moveDocument": "Flyt dokument",
  "moveDocumentTo": "Flyt til {{ destination }}",
  "moveToCustomerResponse": "Tilføj som kundens svar",
  "name": "Navn",
  "next": "Næste",
  "no": "nej",
  "noCustomerResponse": "Der er ikke registreret et svar fra kunden.",
  "none": "Ingen",
  "notApproved": "Ikke godkendt",
  "note": "Note",
  "notification.overdue": "Overskredet",
  "notification.passed": "Passeret",
  "notified": "Adviseret",
  "notified.short": "Adv.",
  "notRelevant": "Ikke relevant",
  "notSpecified": "Ikke angivet",
  "optional": "valgfrit",
  "overview": "Overblik",
  "page.inDevelopment": "Siden er under udvikling",
  "payment_one": "betaling",
  "payment_other": "betalinger",
  "pdf": "PDF",
  "phone": "Telefon",
  "pick.calculation_one": "Vælg $t(common:calculation_one)",
  "pick.calculation_other": "Vælg $t(common:calculation_other)",
  "pick.contact.button": "Godkend",
  "pick.contact.subTitle": "Vælg kontaktperson",
  "pick.contact.title": "Redigér modtager",
  "pickDocument": "Vælg dokument",
  "picked.calculation_one": "Valgt $t(common:calculation_one)",
  "picked.calculation_other": "Valgte $t(common:calculation_other)",
  "powerOfAttorney": "fuldmagtshavere",
  "primaryContact.missing": "Der er ikke tilknyttet en primær kontakt til denne kunde",
  "principalAmount": "hovedstol",
  "principalAmount_specific": "hovedstolen",
  "productType": "produkttype",
  "productType_specific": "produkttypen",
  "projectName": "Projektnavn",
  "recalculate": "Genberegn",
  "recipient_one": "Modtager",
  "recipient_other": "Modtagere",
  "redemptionType.placeholder": "Vælg $t(common:redemptionType.title)",
  "redemptionType.title": "Indfrielsestype",
  "relation_one": "relation",
  "relation_other": "relationer",
  "reminder.expiringInterestAgreement": "Påmindelse om udløbende renteaftale",
  "repaymentInfo": "Afdragsoplysninger",
  "role": "Rolle",
  "role_one": "Rolle",
  "role_other": "Roller",
  "save": "gem",
  "saveAndApprove": "Gem og godkend",
  "search.button": "Søg",
  "search.clear": "Ryd",
  "search.latestSearches": "Seneste resultater",
  "search.noResults": "Ingen søgeresultater fundet",
  "search.noResultsDescription": "Prøv med et andet søgekritere, eller tjek stavningen.",
  "search.results": "Søgeresultater",
  "search.startSearch": "Start ny søgning",
  "search.title": "Søgning",
  "search.viewAllResults": "Se alle resultater",
  "see": "Se",
  "select": "Vælg",
  "send.calculation_one": "Send $t(common:calculation_one)",
  "send.calculation_other": "Send $t(common:calculation_other)",
  "send.calculations.modal.attachments": "Vedhæftede beregninger ({{ count }})",
  "send.calculations.modal.button": "Send $t(common:calculation_other) ({{ count }})",
  "send.calculations.modal.description": "Beregningerne er estimerede og således ikke bindende. For indgåelse af aftale, vælg i stedet \"Indgå aftale\".",
  "send.reminder": "Send påmindelse",
  "sendTo": "Send til {{ recipient }}",
  "sent.calculation_one": "Sendt $t(common:calculation_one)",
  "sent.calculation_other": "Sendte $t(common:calculation_other)",
  "sent.reminders": "Sendte påmindelser ({{ count }})",
  "reminders.none": "Der er endnu ikke sendt nogen påmindelser",
  "reminder.send.success": "Påmindelse sendt",
  "sort": "Sortér",
  "standaloneCalculator": "Låneberegner",
  "standaloneCalculator.form.title": "Estimer aftalelån",
  "startDate": "startdato",
  "startDate_specific": "startdatoen",
  "status": "Status",
  "status.awaiting": "Afventer",
  "status.fail": "Afvist",
  "status.rejected": "Afvist",
  "status.in-progress": "I gang",
  "status.new": "Ny!",
  "status.pending": "Ikke startet",
  "status.success": "Gennemført",
  "status.waiting": "Afventer {{ awaiting }}",
  "term_one": "{{ count }} termin",
  "term_other": "{{ count }} terminer",
  "total": "Total",
  "unavailable": "Ikke tilgængelig",
  "unknownName": "Ukendt navn",
  "unsupported": "Ikke understøttet",
  "update": "Opdater",
  "user.viewProfile": "Se profil",
  "uuid": "UUID",
  "valueDate": "Valørdato",
  "year": "år",
  "yes": "ja",
  "newInterestAgreement": "Ny renteaftale"
}
